import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { UserValidation } from 'app/general/_models/user-validation-model';
import { UserValidationEnum } from 'app/general/_models/user-validation-enum';
import { environment } from '../../../../../environments/environment';
import { AccountService } from 'app/account/account.service';
import { NotificationService } from 'app/_services/notification.service';

declare const $: any;

@Component({
    selector: 'app-user-validation-modal', templateUrl: './user-validation-modal.component.html', styleUrls: ['./user-validation-modal.component.scss'],
    standalone: false
})
export class UserValidationModalComponent implements OnInit {
    public enableUserVerificationCloseButton: boolean = environment.enableUserVerificationCloseButton;

    @ViewChild('templateUserValidationModal') template: TemplateRef<any>;
    modalRef: BsModalRef;

    user: UserValidation;
    navigationStepList: string[] = [];
    currentStep: number = 0;
    isWhatsapp: boolean = false;

    constructor(private accountService: AccountService, private notificationService: NotificationService, private modalService: BsModalService) {}

    ngOnInit(): void {
        this.navigationStepList.push(UserValidationEnum.Data);
    }

    async close(): Promise<void> {
        this.modalRef.hide()
    }

    open(user: UserValidation) {
        if (user.isEmailVerified && user.isWhatsAppVerified)
            return;

        if (!user.isEmailVerified)
            this.navigationStepList.push(UserValidationEnum.Email);

        if (!user.isWhatsAppVerified)
            this.navigationStepList.push(UserValidationEnum.Whatsapp);

        this.user = user;
        let options: ModalOptions = { class: 'custom-modal modal-xsm', backdrop: 'static', keyboard: false };
        this.modalRef = this.modalService.show(this.template, options);
    }

    changeStep(): void {
        this.currentStep++;

        if (this.navigationStepList[this.currentStep] == 'Whatsapp') {
            this.isWhatsapp = true;
        }
    }

    async logout() {
        if (!await this.notificationService.showConfirmationDialog('geral.user-validation.footer.logout.message'))
            return;

        this.close();
        this.accountService.logout();
    }
}
